import ArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IconButton } from "@mui/material";
import { EntriesTableCell } from "../styles";

const ExpandCollapseButton = ({
  isFirstGroup,
  onClick,
  open,
}: {
  isFirstGroup: boolean;
  onClick: () => void;
  open: boolean;
}) => {
  const iconStyles = {
    width: "16px",
    height: "16px",
    stroke: "rgba(0, 0, 0, 0.87)",
  };
  return (
    <EntriesTableCell padding="none" align="center" noBorder>
      {isFirstGroup && (
        <IconButton
          sx={{ border: "1px solid #A273E1" }}
          size="small"
          onClick={(e) => {
            onClick();
            e.stopPropagation();
          }}
        >
          {open ? (
            <ArrowLeftIcon sx={iconStyles} />
          ) : (
            <ArrowRightIcon sx={iconStyles} />
          )}
        </IconButton>
      )}
    </EntriesTableCell>
  );
};

export default ExpandCollapseButton;
